import { Suspense, lazy } from "react";
import { HashRouter as Router, Routes as ReactRouterRoutes, Route} from "react-router-dom";
import { Backdrop, CircularProgress } from "@mui/material";

import { AuthenticatedRoute, Login, ForgotPassword, ResetPassword, NotFound, ChangePassword, LoginWithToken} from "@sal/portal";
import { useAuth } from "@sal/authentication.react";

const PageLayout = lazy(() => import("./PageLayout"));
const Home = lazy(() => import("./pages/home/Home"));
const ProductList = lazy(() => import("./pages/product/ProductList"));
const Product = lazy(() => import("./pages/product/Product"));
const ProjectList = lazy(() => import("./pages/project/ProjectList"));
const Project = lazy(() => import("./pages/project/Project"));
const QuoteList = lazy(() => import("./pages/quote/QuoteList"));
const Quote = lazy(() => import("./pages/quote/Quote"));
const UserList = lazy(() => import("./pages/user/UserList"));
const User = lazy(() => import("./pages/user/User"));
const CountryListing = lazy(() => import("./pages/country/CountryListing"));
const CountryObject = lazy(() => import("./pages/country/CountryObject"));
const Account = lazy(() => import("./pages/account/Account"));
const Settings = lazy(() => import("./pages/settings/Settings"));
const Sandbox = lazy(() => import("./pages/sandbox/Sandbox"));
const RegressionTesting = lazy(() => import("./pages/regressionTesting/RegressionTesting"));
const SsoLoginPage = lazy(() => import("./pages/SsoLoginPage"));
const SalCoreLoginPage = lazy(() => import("./pages/SalCoreLoginPage"));
const SsoCallbackPage = lazy(() => import("./pages/SsoCallbackPage"));

export default function Routes() {
	const auth = useAuth();
	const menuWidth = 256;

	return (
		<Router>
			<Suspense fallback={<Backdrop invisible open><CircularProgress /></Backdrop>}>
				{/*{auth.isLoggedIn ? <Menu width={menuWidth} /> : null}*/}
				<ReactRouterRoutes>
					<Route element={<PageLayout menuWidth={menuWidth} />}>
						<Route element={<AuthenticatedRoute />}>
							<Route path="/" element={<Home />} />
							<Route path="/ProductList" element={
								<AuthenticatedRoute securityContext="Routes" securityContextPermission="ProductList">
									<ProductList />
								</AuthenticatedRoute>}
							/>
							<Route path="/Product/:id?" element={
								<AuthenticatedRoute securityContext="Routes" securityContextPermission="ProductObject">
									<Product />
								</AuthenticatedRoute>}
							/>
							<Route path="/ProjectList" element={
								<AuthenticatedRoute securityContext="Routes" securityContextPermission="ProjectList">
									<ProjectList />
								</AuthenticatedRoute>}
							/>
							<Route path="/Project/:id?" element={
								<AuthenticatedRoute securityContext="Routes" securityContextPermission="ProjectObject">
									<Project />
								</AuthenticatedRoute>}
							/>
							<Route path="/QuoteList" element={
								<AuthenticatedRoute securityContext="Routes" securityContextPermission="QuoteList">
									<QuoteList />
								</AuthenticatedRoute>}
							/>
							<Route path="/Quote/:id?" element={
								<AuthenticatedRoute securityContext="Routes" securityContextPermission="QuoteObject">
									<Quote />
								</AuthenticatedRoute>}
							/>
							<Route path="/UserList" element={
								<AuthenticatedRoute securityContext="Routes" securityContextPermission="UserList">
									<UserList />
								</AuthenticatedRoute>}
							/>
							<Route path="/User/:id?" element={
								<AuthenticatedRoute securityContext="Routes" securityContextPermission="UserObject">
									<User />
								</AuthenticatedRoute>}
							/>
							<Route path="/Account" element={
								<AuthenticatedRoute securityContext="Routes" securityContextPermission="Account">
									<Account />
								</AuthenticatedRoute>
							}
							/>
							<Route path="/Settings" element={
								<AuthenticatedRoute securityContext="Setting" securityContextPermission="Write">
									<Settings />
								</AuthenticatedRoute>}
							/>
							<Route path="/Sandbox" element={
								<AuthenticatedRoute securityContext="Routes" securityContextPermission="Sandbox">
									<Sandbox />
								</AuthenticatedRoute>}
							/>
							<Route path="/RegressionTesting" element={
								<AuthenticatedRoute securityContext="Routes" securityContextPermission="Sandbox">
									<RegressionTesting />
								</AuthenticatedRoute>}
							/>
							<Route path="/CountryListing" element={<CountryListing />} />
							<Route path="/Country/:id?" element={<CountryObject />} />
						</Route>
					</Route>

					{/* PORTAL FRAMEWORK PAGES*/}
					<Route path="/LoginWithToken/:token/:returnUrl?" element={<LoginWithToken />} />
					<Route path="/Login" element={<SsoLoginPage />} />
					<Route path="/SalCoreLogin" element={<SalCoreLoginPage />} />
					<Route path="/SsoCallback" element={<SsoCallbackPage />} />
					<Route path="/ForgotPassword" element={<ForgotPassword />} />
					<Route path="/ChangePassword" element={<ChangePassword />} />
					<Route path="/ResetPassword/:passwordResetToken" element={<ResetPassword />} />
					<Route path="/NotFound" element={<NotFound />} />
					<Route path="*" element={<NotFound />} />
					{/* /PORTAL FRAMEWORK PAGES*/}
				</ReactRouterRoutes>
			</Suspense>
		</Router>
	);
}
